const types = {
  SEARCH_START: 'autoComplete/SEARCH_START',
  SEARCH_SUCCESS: 'autoComplete/SEARCH_SUCCESS',
  SEARCH_FAILURE: 'autoComplete/SEARCH_FAILURE',
  RESET_LIST: 'autoComplete/RESET_LIST',
  SAVE_SELECTED_PLACE: 'autoComplete/SAVE_SELECTED_PLACE',
  UNLOADING_SEARCH_RESULTS_START: 'autoComplete/UNLOADING_SEARCH_RESULTS_START',
  UNLOADING_SEARCH_RESULTS_SUCCESS: 'autoComplete/UNLOADING_SEARCH_RESULTS_SUCCESS',
  UNLOADING_SEARCH_RESULTS_FAILURE: 'autoComplete/UNLOADING_SEARCH_RESULTS_FAILURE',
};

export default types;
